<template>
    <div class="left-menu-wrap">
        <div class="menu-wrap d-flex flex-wrap border text-left">
            <div class="col-12 border-bottom py-2">
                <a v-bind:href="apiRoot+'user/admin'">{{$ml.with('VueJS').get('AdminPanelUsersManager')}}</a>
            </div>
            <div class="col-12 border-bottom py-2">
                <a v-bind:href="adminRoot+'index.php?r=user%2Fadmin'">{{$ml.with('VueJS').get('UsersManager')}}</a>
            </div>
            <!--<div class="col-12 border-bottom py-2 pl-0" v-if="canAccess([
              'Administrator',
              ])">
                <router-link
                        to="/users-manager"
                        v-slot="{ href, route, navigate, isActive }"
                >
                    <div class="d-flex flex-wrap">
                        <div class="col-10">
                            <a :href="href" @click="navigate">{{$ml.with('VueJS').get('UsersManager')}}</a>
                        </div>
                        <div class="col-2 text-center align-self-center">
                            <font-awesome-icon icon="exclamation-circle" v-if="isActive"></font-awesome-icon>
                        </div>
                    </div>
                </router-link>
            </div>-->

            <div class="col-12 border-bottom py-2 pl-0" v-if="canAccess([
              'Administrator',
              'GoodsAdmin',
              ])">
                <router-link
                        to="/pc-products-upload"
                        v-slot="{ href, route, navigate, isActive }"
                >
                    <div class="d-flex flex-wrap">
                        <div class="col-10">
                            <a :href="href" @click="navigate">{{$ml.with('VueJS').get('PCProductsModeration')}}</a>
                        </div>
                        <div class="col-2 text-center align-self-center">
                            <font-awesome-icon icon="exclamation-circle" v-if="isActive"></font-awesome-icon>
                        </div>
                    </div>
                </router-link>
            </div>

            <div class="col-12 border-bottom py-2 pl-0" v-if="canAccess([
              'Administrator',
              'GoodsAdmin',
              ])">
                <router-link
                        to="/pc-products"
                        v-slot="{ href, route, navigate, isActive }"
                >
                    <div class="d-flex flex-wrap">
                        <div class="col-10">
                            <a :href="href" @click="navigate">{{$ml.with('VueJS').get('PharmCompanyProducts')}}</a>
                        </div>
                        <div class="col-2 text-center align-self-center">
                            <font-awesome-icon icon="exclamation-circle" v-if="isActive"></font-awesome-icon>
                        </div>
                    </div>
                </router-link>
            </div>

            <div class="col-12 border-bottom py-2 pl-0" v-if="canAccess([
              'Administrator',
              'GoodsAdmin',
              ])">
                <router-link
                        to="/pc-items-for-moderation"
                        v-slot="{ href, route, navigate, isActive }"
                >
                    <div class="d-flex flex-wrap">
                        <div class="col-10">
                            <a :href="href" @click="navigate">{{$ml.with('VueJS').get('RequestsModerationTitle')}}</a>
                        </div>
                        <div class="col-2 text-center align-self-center">
                            <font-awesome-icon icon="exclamation-circle" v-if="isActive"></font-awesome-icon>
                        </div>
                    </div>
                </router-link>
            </div>

            <div class="col-12 border-bottom py-2 pl-0" v-if="canAccess([
              'Administrator',
              'OrdersAdmin',
              ])">
                <router-link
                        to="/orders-list"
                        v-slot="{ href, route, navigate, isActive }"
                >
                    <div class="d-flex flex-wrap">
                        <div class="col-10">
                            <a :href="href" @click="navigate">{{$ml.with('VueJS').get('OrdersList')}}</a>
                        </div>
                        <div class="col-2 text-center align-self-center">
                            <font-awesome-icon icon="exclamation-circle" v-if="isActive"></font-awesome-icon>
                        </div>
                    </div>
                </router-link>
            </div>

            <div class="col-12 border-bottom py-2 pl-0">
                <router-link
                        to="/profile"
                        v-slot="{ href, route, navigate, isActive }"
                >
                    <div class="d-flex flex-wrap">
                        <div class="col-10">
                            <a :href="href" @click="navigate">{{$ml.with('VueJS').get('Profile')}}</a>
                        </div>
                        <div class="col-2 text-center align-self-center">
                            <font-awesome-icon icon="exclamation-circle" v-if="isActive"></font-awesome-icon>
                        </div>
                    </div>
                </router-link>
            </div>

            <div class="col-12 py-2">
                <a href="#" @click="logout()">{{$ml.with('VueJS').get('Logout')}}</a>
            </div>
        </div>
    </div>
</template>

<script>
  import mixinUtils from "@/components/mixinUtils";
  import { apiRoot } from "@/helpers/variables";
  import { adminRoot } from "@/helpers/variables";


  export default {
    name: 'NavMenu',
    mixins: [mixinUtils],
    components: {
    },
    data: () => ({
        apiRoot: apiRoot,
        adminRoot: adminRoot,
    }),
    methods: {
      logout () {
        this.$store.commit('logOut');
        this.$router.push({path: '/login'})
      }
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      isAuthenticated() {
        return this.$store.state.isAuthenticated;
      },
      systemId() {
        return this.$store.state.systemId;
      }
    },
    mounted() {
    }
  }
</script>